import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function ProjectDetails({ label, projectName }) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={projectName}
            />
        </EuiFlexItem>
    );
}
